export default {"src":"__ASTRO_ASSET_IMAGE__C28aGiBJ__","width":352,"height":438,"format":"png"}